var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 8.33325,
    rx: 2.5,
    ry: 2.5,
    stroke: "#657397",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3891 6.10101C15.6823 6.80875 15.8332 7.56729 15.8332 8.33333C15.8332 10.4676 14.9853 12.5145 13.4761 14.0237L9.99984 17.5L6.52353 14.0237C5.01435 12.5145 4.1665 10.4676 4.1665 8.33333C4.1665 7.56729 4.31739 6.80875 4.61054 6.10101C4.90369 5.39328 5.33337 4.75022 5.87505 4.20854C6.41672 3.66687 7.05978 3.23719 7.76752 2.94404C8.47525 2.65088 9.23379 2.5 9.99984 2.5C10.7659 2.5 11.5244 2.65088 12.2322 2.94404C12.9399 3.23719 13.583 3.66687 14.1246 4.20854C14.6663 4.75022 15.096 5.39328 15.3891 6.10101Z",
    stroke: "#657397",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.22b0558a57469515d03014490df877be.svg";
export { ForwardRef as ReactComponent };